import {
  EMPTY_STRING,
  globalConstants,
} from "../../constants/global.constants";

const request = (data, type, component = EMPTY_STRING) => {
  return {
    type:
      (component ? `${component}_` : EMPTY_STRING) +
      type +
      globalConstants.REQUEST,
    data,
  };
};

const success = (data, type, component = EMPTY_STRING) => {
  return {
    type:
      (component ? `${component}_` : EMPTY_STRING) +
      type +
      globalConstants.SUCCESS,
    data,
  };
};

const failure = (data, type, component = EMPTY_STRING) => {
  return {
    type:
      (component ? `${component}_` : EMPTY_STRING) +
      type +
      globalConstants.FAILURE,
    data,
  };
};

const custom = (data, type, component = EMPTY_STRING) => {
  return { type: (component ? `${component}_` : EMPTY_STRING) + type, data };
};

export { request, success, failure, custom };
